import { useState } from 'react'

import { CurrencyContext } from '../currencyContext/currencyContext'

import { CurrencyCode } from '@percent/utility'
import { CurrencyContextControllerProps } from './currencyContextController.types'

export function CurrencyContextController({ children }: CurrencyContextControllerProps) {
  const [currency, setCurrency] = useState<undefined | CurrencyCode>()

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  return <CurrencyContext.Provider value={{ currency, setCurrency }}>{children}</CurrencyContext.Provider>
}
